import Control from './control';
import Doublebox from './doublebox';
import Singlebox from './singlebox';
import Opendesign from './opendesign';
import FakeDoor from './fakedoor';
import FreeAccount from './free-account';

import LaunchDarkly from '@module/launchdarkly';
import {
  EXPERIMENT_SPLASHPAGE_COPY,
  EXPERIMENT_SPLASHPAGE_FAKE_DOOR,
  EXPERIMENT_FREE_ACCOUNT,
} from '@constant/experiments';

// ==================
// Experiment details
// A. Fake door experiment returns a boolean, redesign experiment returns a string
// B. Fake door experiment targets India traffic, which is excluded in redesign experiment.

// To show splashpage variant appending one of the following to the URL
// #ab_splashpage-redesign=doublebox
// #ab_splashpage-fake-door=true
// ==================

let component = Control;

if (LaunchDarkly.getVariant(EXPERIMENT_FREE_ACCOUNT)) {
  component = FreeAccount;
} else if (LaunchDarkly.getVariant(EXPERIMENT_SPLASHPAGE_FAKE_DOOR)) {
  component = FakeDoor;
} else {
  const variant = LaunchDarkly.getVariant(EXPERIMENT_SPLASHPAGE_COPY);

  const VariantToComponentMap = {
    doublebox: Doublebox,
    singlebox: Singlebox,
    opendesign: Opendesign,
  };

  component = VariantToComponentMap[variant] || Control;
}

export default component;
